import React, {useEffect, useState} from "react";
import {MetricsSummary} from "./MetricsSummary";
import {faFaceSmile} from "@fortawesome/free-solid-svg-icons";
import {calculateSatisfaction} from "../../model/dashboardAnalytics";
import {getGroupPathByName} from "../../model/dashboardHelpers";
import {GroupButtons} from "../../../organizationManagement/components/GroupButtons";
import {Typography} from "../../../../designSystem/components/Typography";
import {BeautifulTable} from "../BeautifulTable";
import {DashboardCard} from "../../../../designSystem/components/DashboardCard";

type AvgRow = { question: string; count: number };

export const SurveySummary = ({ cases, selectedGroup, onChangeSelectedGroup }) => {
  const [averageScoreArray, setAverageScoreArray] = useState([])
  const [overallAverage, setOverallAverage] = useState(0)

  useEffect(() => {
    const groupPath = getGroupPathByName(selectedGroup)
    const filteredCases = cases
      .filter(c => {
        if (groupPath === '') return true;
       return (c.category === groupPath)
      })
    const { tempAverageScoreArray, tempOverallAverage } = calculateSatisfaction(filteredCases)
    setAverageScoreArray(tempAverageScoreArray)
    setOverallAverage(tempOverallAverage)
  }, [cases, selectedGroup])

  return (
    <DashboardCard>
      <Typography variant="subtitle">
        滿意度人次分析
      </Typography>

      <GroupButtons
        selectedGroup={selectedGroup}
        onChangeSelectedGroup={onChangeSelectedGroup}
      />

      <MetricsSummary
        title="滿意度總平均"
        value={overallAverage.toFixed(2)}
        icon={faFaceSmile}
        iconColor="text-orange-500"
      />

      <BeautifulTable<AvgRow>
        rows={averageScoreArray}
        getRowKey={(row) => row.question}
        columns={[
          {
            key: 'question',
            header: <Typography variant="body">問題</Typography>,
            render: (row) => <Typography variant="body">{row.question}</Typography>,
            cellClassName: 'text-gray-800',
          },
          {
            key: 'avg',
            header: <Typography variant="body">平均分</Typography>,
            align: 'right',
            headerClassName: 'text-nowrap',
            cellClassName: 'font-medium text-gray-700',
            render: (row) => <Typography variant="bodyBold">{row.count.toFixed(2)}</Typography>,
          },
        ]}
      />
    </DashboardCard>
  )
}
